
import * as handlebars_family from "../handlebars_family.ts";
import "../widget/action-menu.ts";
const TPL = handlebars_family.addTemplate("list/modal_listcategories_item",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <span class=\"flexcenter\" data-widget=\"widget/action-menu\" data-key=\"emojilistcategory\"><input name=\"emoji\" data-type=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"type") : depth0), depth0))
    + "\" type=\"hidden\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "\"><emoji>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji></span> ";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <emoji>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji> ";
},"5":function(container,depth0,helpers,partials,data) {
    return "readonly";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"listcatdelete\" class=\"color-branded\" style=\"display:none;margin-right:var(--space-xs)\"> "
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_delete_circle",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":807},"end":{"line":1,"column":837}}}))
    + " </icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div draggable=\"true\" class=\"listcategoryedit flexrow\" style=\"background:white;border-radius:4px;border:var(--border);margin-top:2px;\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"><span style=\"padding:8px;width:40px;display:inline-block;text-align:center\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":243},"end":{"line":1,"column":509}}})) != null ? stack1 : "")
    + " </span><input class=\"flexauto\" "
    + ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canUpdate") : stack1),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":541},"end":{"line":1,"column":588}}})) != null ? stack1 : "")
    + " name=\"name\" style=\"border:none;margin-top:0;padding-left:8px\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"rights") : depth0)) != null ? lookupProperty(stack1,"canDelete") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":671},"end":{"line":1,"column":853}}})) != null ? stack1 : "")
    + " <icon data-fw-onclick=\"listcatclick\" style=\"margin-right:var(--space-xs)\"> "
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_drag",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":929},"end":{"line":1,"column":950}}}))
    + " </icon></div>";
},"useData":true});
export default TPL;